const instructionsUrl = 'https://instructions.documents.cimpress.io/';

export function buildInstructionsUri(documentUri: string): string {
  return `${instructionsUrl}v3/instructions:preview?documentUri=${encodeURIComponent(documentUri)}`;
}
